import React from "react";
import { Link } from "react-router-dom";
import { Mail, Linkedin, Twitter, MapPin } from "lucide-react";
import { eventInfo, nav } from "../mock";
import Wordmark from "./Wordmark";

const Footer = () => {
  return (
    <footer className="aaa-bg-near-black text-white pt-20 pb-8 border-t border-white/5">
      <div className="max-w-[1320px] mx-auto px-5 sm:px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 pb-12">
          <div className="lg:col-span-5">
            <Wordmark size="md" variant="light" layout="horizontal" />
            <div className="text-[11px] tracking-[0.2em] uppercase text-white/50 mt-3">An Ecosystm gathering</div>
            <h3 className="font-display text-3xl leading-tight max-w-md mt-6 font-semibold">
              {eventInfo.title}: <span className="text-[#ff243d]">{eventInfo.subtitle}</span>
            </h3>
            <div className="mt-6 space-y-2 text-sm text-white/70">
              <div className="flex items-center gap-2"><MapPin className="w-4 h-4 text-[#ff243d]" /> {eventInfo.venue}</div>
            </div>
            <p className="text-xs text-white/50 mt-6 max-w-md leading-relaxed">{eventInfo.status}</p>
          </div>

          <div className="lg:col-span-4">
            <div className="text-[11px] tracking-[0.2em] uppercase text-white/50 mb-4">Event</div>
            <ul className="space-y-3 text-sm">
              {nav.map((n) => (
                <li key={n.to}>
                  <Link to={n.to} className="text-white/80 hover:text-[#ff243d] transition-colors">{n.label}</Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <div className="text-[11px] tracking-[0.2em] uppercase text-white/50 mb-4">Connect</div>
            <div className="flex gap-3">
              <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:border-[#ff243d] hover:text-[#ff243d] transition"><Linkedin className="w-4 h-4" /></a>
              <a href="#" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:border-[#ff243d] hover:text-[#ff243d] transition"><Twitter className="w-4 h-4" /></a>
              <a href="mailto:info@ecosystm.io" className="w-9 h-9 rounded-full border border-white/20 flex items-center justify-center hover:border-[#ff243d] hover:text-[#ff243d] transition"><Mail className="w-4 h-4" /></a>
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between text-xs text-white/50">
          <div>&copy; {new Date().getFullYear()} Ecosystm. Asia AI Alliance is editorially independent.</div>
          <div>info@ecosystm.io</div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
